import { SortButton } from "../Buttons/SortButton/SortButton"
import { DataTableProps } from "./DataTable"

export const TableHeaders = ({ tableHeaders, totalsKeys, format, mapKeys, data, sortState, handleHeaderClick }: DataTableProps & { headerKey?: string, handleHeaderClick?: (x: string) => void, totalsKeys?: string[]}) => {

  if (!tableHeaders) return <>missing table headers</>
  
  return tableHeaders?.map((x, i) => {
   
    let headerClass = 'cell header'
    
    if (i === 0) headerClass += ' is-first'
    if (i === (tableHeaders?.length || 0) - 1) headerClass += ' is-last'
    
    let cellSettings = {
      className: headerClass,
      dataSets: {
        'data-id': 'header',
        'data-header': x,
        'data-key': x,
        'data-colindex': i + 1,
        'data-rowindex': 0,
        'data-col': (i + 1) % 2 === 0 ? 'even' : 'odd',
        'data-row': 'odd',
        'data-area': x
      },
      direction: sortState?.[x],
      handleClick: () => {
        handleHeaderClick?.(x as string)
      },
    }

    if (totalsKeys?.includes(x as string)) {
      cellSettings = {...cellSettings, styles: {
        gridColumnStart: 'span 2'
      }}
    }
  
    return <SortButton key={i} {...cellSettings}>{x === 'viewMore' ? ' ' : format?.dataTable?.({header: x, data}) || mapKeys?.[x] || x}</SortButton>
  })
}